import React from "react";
import './about.css';
import PageTemplate from "../../templates/page-template/PageTemplate";
import AboutContent from "../../organisms/AboutContent/AboutContent";

const About: React.FC = () => {
    return (
        <PageTemplate children={<AboutContent/>}></PageTemplate>
    );
};

export default About;